import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHouseList, changeTable, getDetail, fetchShareMeterList } from "@/api/PMS/baseInformation/meterManager";
import { fetchList as getMeterTypeList } from "@/api/PMS/baseInformation/meterType";
export default {
  data: function data() {
    return {
      rules: {
        houseId: [{
          required: true,
          message: "请选择房间",
          trigger: "blur"
        }],
        meterId: [{
          required: true,
          message: "请选择仪表类型",
          trigger: "blur"
        }],
        maxReadNumber: [{
          required: true,
          type: 'number',
          message: '请输入最大读数，类型为数字,0<=最大读数<=100000',
          trigger: 'blur',
          max: 100000,
          min: 0,
          transform: function transform(value) {
            return Number(value);
          }
        }],
        initReadNumber: [{
          required: true,
          type: 'number',
          message: '请输入初始读数，类型为数字，0<=初始读数<=100000',
          trigger: 'blur',
          max: 100000,
          min: 0,
          transform: function transform(value) {
            return Number(value);
          }
        }],
        meterMagnification: [{
          required: true,
          type: 'number',
          message: '请输入倍率，类型为数字,0<倍率<100',
          max: 99.99,
          min: 0.01,
          trigger: 'blur',
          transform: function transform(value) {
            return Number(value);
          }
        }],
        wastingRate: [{
          type: 'number',
          transform: function transform(value) {
            console.log(Number(value));
            if (value !== undefined && value !== null) return Number(value);
          },
          max: 99.99,
          min: 0,
          message: '损耗率类型为数字,类型为数字,0<=损耗率<100',
          trigger: 'blur'
        }],
        meterName: [{
          required: true,
          message: '请输入仪表名称，仪表名称1-20个字符',
          trigger: 'blur',
          max: 20,
          min: 0
        }],
        changeReadNumber: [{
          required: true,
          type: 'number',
          message: '请输入原仪表更换时读数，类型为数字，0<=初始读数<=100000',
          trigger: 'blur',
          max: 100000,
          min: 0,
          transform: function transform(value) {
            return Number(value);
          }
        }],
        initReadNumberOld: [{
          required: true,
          type: "number",
          message: "请输入初始读数，类型为数字",
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        initDate: [{
          required: true,
          message: "请选择初始日期",
          trigger: "blur"
        }],
        initDateOld: [{
          required: true,
          message: "请选择初始日期",
          trigger: "blur"
        }],
        meterNameOld: [{
          required: true,
          message: "请输入仪表名称",
          trigger: "blur"
        }]
      },
      meterId: 0,
      shareMeterList: [],
      meterTypeList: [],
      houseList: [],
      childData: {
        houseId: 0,
        isMaster: 1,
        isReadNumber: 1
      }
    };
  },
  props: ["keyValue", "showDialog"],
  created: function created() {
    this.init();
    this.loadMeterTypeList();
  },
  methods: {
    // 获取用户信息
    getCustomerInfo: function getCustomerInfo(data) {
      // 此处要排除undefined情况，否则会多查询一次
      if (data !== undefined) {
        this.getcustomerHouseData(data);
      }
    },
    // 获取企业房间信息
    getcustomerHouseData: function getcustomerHouseData(data) {
      var _this = this;

      getHouseList({
        houseInfo: data
      }).then(function (r) {
        _this.houseList = r.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          houseMeterId: this.keyValue
        };
        getDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;

          _this2.getCustomerInfo(_this2.childData.houseCode); // this.childData.changeReadNumber = 0


          _this2.$set(_this2.childData, "changeReadNumber", 0);

          _this2.childData.meterNameOld = _this2.childData.meterName;
          _this2.childData.initReadNumberOld = _this2.childData.initReadNumber;
          _this2.childData.initDateOld = _this2.childData.initDate; // 清除旧数据方便更新

          _this2.childData.meterName = undefined;
          _this2.childData.initReadNumber = undefined;
          _this2.childData.initDate = undefined;
          _this2.childData.maxReadNumber = undefined;
          _this2.childData.meterMagnification = undefined; // this.childData.wastingRate = undefined

          _this2.$set(_this2.childData, "wastingRate", undefined);
        });
      } else {
        this.meterId = "";
        this.childData = {
          houseId: 0,
          meterName: "",
          isMaster: 1,
          isReadNumber: 1
        };
      }
    },
    // 客户选择发生变化的时候触发
    customerChange: function customerChange() {
      // 清理总表id
      if (this.childData.shareMeterId) {
        delete this.childData.shareMeterId;
      }

      this.loadShareMeterList();
    },
    // 获取总表列表
    loadShareMeterList: function loadShareMeterList() {
      var _this3 = this;

      fetchShareMeterList({
        shareType: 1,
        areaId: this.childData.houseId
      }).then(function (r) {
        _this3.shareMeterList = r.data.data;
      });
    },
    // 获取仪表类型
    loadMeterTypeList: function loadMeterTypeList() {
      var _this4 = this;

      getMeterTypeList({}).then(function (r) {
        _this4.meterTypeList = r.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this5 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          // console.log((+this.childData.changeReadNumber) < (+this.childData.initReadNumberOld),(+this.childData.changeReadNumber),(+this.childData.initReadNumberOld))
          if (+_this5.childData.initReadNumber >= +_this5.childData.maxReadNumber) {
            return _this5.Alert({
              alertType: "valid",
              message: "初始读数不能大等于最大读数！"
            });
          }

          if (+_this5.childData.changeReadNumber < +_this5.childData.initReadNumberOld) {
            return _this5.Alert({
              alertType: "valid",
              message: "原仪表更换时读数不能小于原仪表上次读数！"
            });
          }

          if (_this5.keyValue > 0) {
            changeTable(_this5.childData).then(function (response) {
              if (response.data.code === 200) {
                _this5.$emit("handCancle", true);

                _this5.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            _this5.Alert({
              alertType: "valid"
            });
          }
        } else {
          _this5.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};